<template>
  <li class="tree-item-container">
    <a
      v-if="node.linkUrl"
      :href="node.linkUrl"
      :class="{ 'is-active': isActive }"
      @click.prevent="emitClick(node)"
    >
      {{ node.label }}
    </a>
    <ul v-show="isExpanded" v-if="node.children.length > 0">
      <Tree
        v-for="(child, ind) in node.children"
        ref="trees"
        :key="ind"
        :index="ind"
        :node="child"
        @expanded="onExpand"
        @clicked="emitClick"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'Tree',
  props: {
    /**
     * An object that refers to a node on the tree structure. It can be the root node or leaf node
     *  Given that this component is used recursively, this node will be both root & leaf
     * Schema:
     *  {
     *    label: string;
     *    linkUrl?: string; // If have, will be an <a>
     *    isActive: boolean; // only 1 can be isActive at 1 time
     *    ... // Others that will be returned as part of the node object on click
     *    children: [] // array of this object
     *  }
     *
     * @type {object}
     */
    node: {
      type: Object,
      required: true
    },
    /**
     * Index of the list of node. This is used to identify which of the component that emit the isExpanded event
     *
     * @type {number}
     */
    index: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      isExpanded: !!this.node.isActive
    }
  },
  computed: {
    isActive() {
      return !!this.node?.isActive
    }
  },
  watch: {
    isActive(newVal, _) {
      this.isExpanded = newVal
      if (this.isExpanded) {
        // Close all my children nodes when current node is expanded
        this.$refs.trees?.forEach((tree) => (tree.isExpanded = false))
        this.emitOnExpand()
      }
    }
  },
  beforeMount() {
    if (this.isExpanded) {
      this.emitOnExpand()
    }
  },
  methods: {
    emitOnExpand() {
      const emitData = {
        toExpand: true,
        index: this.index
      }
      this.$emit('expanded', emitData)
    },
    onExpand({ toExpand, index }) {
      this.isExpanded = toExpand
      // Close all my children node except the one that emit the expanded
      this.$refs.trees
        ?.filter((tree) => tree.index !== index)
        ?.forEach((tree) => (tree.isExpanded = false))
      this.emitOnExpand(toExpand)
    },
    emitClick(node) {
      // This is done in this manner so that the consuming component can decide which property they need
      const noChildrenNode = { ...node }
      delete noChildrenNode.children
      this.$emit('clicked', noChildrenNode)
    }
  }
}
</script>

<style lang="scss" scoped>
.tree-item-container {
  text-transform: capitalize;
}
.is-active {
  color: $primary;
}
li {
  list-style: none;
  padding: 3px 0;
  line-height: 18px;
}
ul {
  margin-left: 20px;
  padding-top: 6px;
}
</style>
